<template>
    <b-modal
        @ok="generateReport"
        class="pt-8"
        v-model="showModal"
        title="Select Report Type"
    >
        <template #default>
            <b-form class="mt-3" submit.prevent="doNothing()">
                <b-form-group label="Report Types" v-slot="{ ariaDescribedby }">
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="asset_details"
                        id="asset_details"
                        >Asset Service History</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="asset_header"
                        id="asset_header"
                        >Asset Summary Report</b-form-radio
                    >
                </b-form-group>
            </b-form>
        </template>

        <template #modal-footer="{ ok, cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button
                size="sm"
                :disabled="!reportType"
                variant="success"
                @click="ok()"
            >
                <b-spinner
                    v-show="report_loading"
                    variant="primary"
                    label="Spinning"
                ></b-spinner>
                <span v-show="!report_loading">Create Report</span>
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import reportMixins from '@/mixins/reportMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assets-exportDetails',
    mixins: [popupMixins, permissionsMixins, reportMixins],
    data() {
        return {
            showModal: false,
            reportType: null,
            resetCounter: 0,
            queryModel: {},
        }
    },
    props: ['queryData'],

    watch: {
        queryData: function (val) {
            this.queryModel = val || {}
        },
    },
    mounted() {
        this.queryModel = this.queryData || {}
    },
    methods: {
        show() {
            this.showModal = true
        },
        close() {
            this.showModal = false
        },
        getQueryString(rpt_type) {
            this.$set(this.queryModel, 'rpt_type', rpt_type)
            return `&query=${btoa(JSON.stringify(this.queryModel))}`
        },

        doNothing() {},
    },
}
</script>

<style scoped>
</style>